import { Controller } from "stimulus";

export default class FixedPlayerController extends Controller {
  connect() {
    window.addEventListener("supercast-timeupdate", this.update.bind(this));
    window.addEventListener("supercast-playback-ended", this.loadNextEpisode.bind(this));
    const currentEpisodeId = null;
  }

  update(event) {
    if (event.detail.mediaType != 'audio') {
      this.hide();
      return;
    }
    this.show();
    if (event.detail.itemId == this.currentEpisodeId) {
      return;
    }
    this.currentEpisodeId = event.detail.itemId;
    if (event.detail.itemType == "Episode") {
      this.fetchMetadataStream(event.detail.itemId);
      this.setFeedTokenConnected(event.detail.itemId);
    }
  }

  show() {
    this.element.hidden = false;
  }

  hide() {
    this.element.hidden = true;
  }

  fetchMetadataStream(episodeId) {
    fetch(`/subscriber_v2/episodes/${episodeId}/metadata${window.location.search}`, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
      }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html));
  }

  setFeedTokenConnected(episodeId) {
    fetch(`/subscriber_v2/feed_items/mark_feed_token_connected?episode_id=${episodeId}`, {
      method: "POST"
    });
  }

  loadNextEpisode() {
    if (this.hasNextEpisodePlayButtonTarget) {
      const playController = this.application.getControllerForElementAndIdentifier(this.nextEpisodePlayButtonTarget.querySelector("[data-controller='play-button']"), "play-button");
      playController.play();
    }
  }
}

FixedPlayerController.targets = ['nextEpisodePlayButton'];
